module.exports = __webpack_public_path__ + "img/user-engagement-male.5937a93b.png";